import React from "react";
import { useSelector } from "react-redux";

import { LoadingSpinner } from "../Shared";
import { Common } from "../../helper";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import Maths from "../../assets/images/MathsClassHome.svg"
import Reading from "../../assets/images/ReadingClassHome.svg"
import Writing from "../../assets/images/WritingClassHome.svg"
import Science from "../../assets/images/ScienceClassHome.svg"
import PE from "../../assets/images/Physical Education.svg"

const ClassHomeSubjects = (props) => {
  let isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)
  const { subject, pupil, index, subjectActualAverages, subjectPredictedAverages, subjectActualOutcomeAverages, subjectPredictedOutcomeAverages, isLoading } = props;
  const tableData = pupil && [...pupil]
  tableData?.unshift([subjectActualAverages, subjectPredictedAverages, subjectActualOutcomeAverages, subjectPredictedOutcomeAverages])

  let bgClass = index % 2 == 0 ? "classHomeSubject-container-bg-light" : "classHomeSubject-container-bg-dark"
  let bgColourClassName = isNavCollapsed ? ("classHomeSubject-containerFullScreen" + " " + bgClass) : ("classHomeSubject-container" + " " + bgClass)

  const subjectIcons = {
    Maths: Maths,
    Reading: Reading,
    Writing: Writing,
    Science: Science,
    PE: PE,
  };

  const markingColour = (marking) => {
    let bg = "none"
    if (!marking) {
      bg = "var(--absent-colour)"
    }
    else {
      let last = marking[1]
      bg = last == "B" ? "var(--below-colour)" : last == "W" ? "var(--emerging-colour)" : last == "E" ? "var(--expected-colour)" : "var(--greater-colour)"
    }
    return bg
  }


  return (
    <>
      {isLoading ? <LoadingSpinner /> : <div className={`${bgColourClassName} classHomeSubject-fix-${index}`}>
        <div className="classHomeSubject-classHead-th">
          <div className="classHome-mathsIcon-subject">
            <img className="classHome-mathsIcon" src={subjectIcons[subject.subject]} alt="Maths" /><span className="classHome-maths-span">{subject.subject}</span>
          </div>
        </div>
        <table className="your-table-class-subject">
          <thead >
            <tr className="classHomeSubject-trAvg">
              <th className="classHomeSubject-tdAvg">
                <div className="KS-containerAvg">
                  <div className="greenPointer"></div>
                  <span className="KS1"></span>
                </div>
              </th>
              <th className="classAverage-td">
                <span className="currentScoreAvg">
                  <span className="currentScoreMarkingAvg" >
                    <span className="currentScoreMarkinTextAvg">{Common.Current}</span>
                  </span>
                  <span className="currentScorePercentage"></span>
                </span>
                <span className="predictedScoreAvg">
                  <span className="predictedScoreMarkingAvg" ><span className="predictedScoreMarkinTextAvg">{Common.Predicted}</span></span><span className="predictedScorePercentage"></span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody className="classHomeSubject-body">
            {
              tableData && tableData.map((e, i) => {
                if (i === 0) {
                  let current, predicted, currentMarking, predictedMarking

                  if (subject.subject == "PE") {
                    current = e[0]["PhysicalEducation"];
                    predicted = e[1]["PhysicalEducation"];
                    currentMarking = subjectActualOutcomeAverages && subjectActualOutcomeAverages["PhysicalEducation"];
                    predictedMarking = subjectPredictedOutcomeAverages && subjectPredictedOutcomeAverages["PhysicalEducation"];
                  } else {
                    current = e[0][subject.subject];
                    predicted = e[1][subject.subject];
                    currentMarking = subjectActualOutcomeAverages && subjectActualOutcomeAverages[subject.subject];
                    predictedMarking = subjectPredictedOutcomeAverages && subjectPredictedOutcomeAverages[subject.subject];
                  }


                  return (
                    <tr className="classHomeSubject-tr" key={i}>
                      <td className="classHomeSubject-td">
                        <div className="KS-container">
                          <div className="greenPointer"></div>
                          <span className="KS1"></span>
                        </div>
                      </td>
                      <td className="classAverage-td">
                        <span className="currentScore">
                          <span className="currentScoreMarking" style={{ backgroundColor: markingColour(currentMarking) }}>
                            <span className="currentScoreMarkinText">{currentMarking ? currentMarking.split("-")[0] : "-"}</span>
                          </span>
                          <span className="currentScorePercentage">{current ? `${Math.round(current)}%` : "0%"}</span>
                        </span>
                        <span className="predictedScore">
                          <span className="predictedScoreMarking" style={{ backgroundColor: markingColour(predictedMarking) }}><span className="predictedScoreMarkinText">{predictedMarking ? predictedMarking.split("-")[0] : "-"}</span></span><span className="predictedScorePercentage">{predicted ? `${Math.round(predicted)}%` : "0%"}</span>
                        </span>
                      </td>
                    </tr>
                  )
                } else {
                  const ks1 = e.ksResult[subject.subject]
                  const outcome = e.subject.find(s => s.name == subject.subject)
                  let current = "";
                  let predicted = "";
                  let currentMarking = "";
                  let predictedMarking = "";

                  if (outcome) {
                    if (outcome.actual !== undefined) {
                      current = outcome.actual;
                    }
                    if (outcome.predicted !== undefined) {
                      predicted = outcome.predicted;
                    }
                    if (outcome.actualOutcome !== undefined) {
                      currentMarking = outcome.actualOutcome;
                    }
                    if (outcome.predictedOutcome !== undefined) {
                      predictedMarking = outcome.predictedOutcome;
                    }
                  }

                  return (
                    <tr className="classHomeSubject-tr" key={i}>
                      <td className="classHomeSubject-td">
                        <div className="KS-container">
                          <div className="greenPointer" style={{ backgroundColor: ks1?.charAt(ks1.length - 1).toUpperCase() === "M" ? "var(--expected-colour)" : ks1?.charAt(ks1.length - 1).toUpperCase() === "L" ? "var(--emerging-colour)" : ks1?.charAt(ks1.length - 1).toUpperCase() === "H" ? "var(--greater-colour)" : "#A8A7A7" }}></div>
                          <span className="KS1">{ks1}</span>
                        </div>
                      </td>
                      <td className="classAverage-td">
                        <span className="currentScore">
                          <span className="currentScoreMarking" style={{ backgroundColor: markingColour(currentMarking) }}><span className="currentScoreMarkinText">{currentMarking ? currentMarking.split("-")[0] : "-"}</span></span><span className="currentScorePercentage">{current ? `${Math.round(current)}%` : "0%"}</span>
                        </span>
                        <span className="predictedScore">
                          <span className="predictedScoreMarking" style={{ backgroundColor: markingColour(predictedMarking) }}><span className="predictedScoreMarkinText">{predictedMarking ? predictedMarking.split("-")[0] : "-"}</span></span><span className="predictedScorePercentage">{predicted ? `${Math.round(predicted)}%` : "0%"}</span>
                        </span>
                      </td>

                    </tr>
                  )
                }
              })
            }
          </tbody>
        </table>
      </div >}
    </>
  );
}

export { ClassHomeSubjects };